import React, { useEffect } from "react";
import AOS from 'aos';
import "aos/dist/aos.css";

const Contact = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
        AOS.refresh();
    }, []);

    return (
        <div
            name="contact"
            className="bg-gradient-to-b from-[#004643] via-[#abd1c6] to-white md:h-auto lg:p-6"
        >
            <div className="max-w-screen-lg p-9 mb-9 mx-auto flex flex-col justify-center w-full" data-aos="zoom-in-up" data-aos-delay="200" data-aos-once="true">
                <div className="pb-8">
                    <p className="text-4xl font-logo border-b-4 border-gray-500 p-2 inline text-[#fffffe]">
                        Contact 📧
                    </p>
                    <p className="py-6 text-[#fffffe]">To get in touch with me, simply fill out the form below and I'll get back to you as soon as possible</p>
                </div>

                <div className=" flex justify-center items-center py-2">
                    <form
                        action="https://formspree.io/f/mjvdooay"
                        method="POST"
                        className=" flex flex-col w-full md:w-2/3"
                    >
                        <input
                            type="text"
                            name="name"
                            placeholder="Enter your name"
                            className="p-2 bg-[#001e1d] rounded-md text-[#fffffe] focus:outline-none shadow-lg"
                            required
                        />
                        <input
                            type="text"
                            name="email"
                            placeholder="Enter your email"
                            className="my-4 p-2 bg-[#001e1d] rounded-md text-[#fffffe] focus:outline-none shadow-lg"
                            required
                        />
                        <textarea
                            name="message"
                            placeholder="Enter your message"
                            rows="10"
                            className="p-2 bg-[#001e1d] rounded-md text-[#fffffe] focus:outline-none shadow-lg"
                            required
                        ></textarea>

                        <button className="text-[#001e1d] bg-gradient-to-tr from-[#fde680] to-[#ffb647] px-6 py-3 mt-6 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
                            Send
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
